<div class="loadingSpinner">
    <i class="fa fa-spinner fa-spin"></i>
  </div>